import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import CustomerColumn from "../../shared/component/dataTable/columns/CustomerColumn.json";
import DataTable from "../../shared/component/dataTable/DataTable";
import '../../shared/styles/SettingsPage.css';

export default class CustomerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.refDataTable.refresh();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        {this.customerList()}
                    </div>
                </AvForm>
            </div>
        );
    }

    customerList() {
        var url = "security/customer/all";
        return (
            <>
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Customers</h1>
                </div>
                <div className="settings-page__panel settings-page__section">
                    <div className="settings-page__table-wrap">
                        <DataTable ref={(elem) => this.refDataTable = elem} fields={CustomerColumn.fields}
                                   objectName={CustomerColumn.name}
                                   dataURL={url}
                                   selectionMode="single" onDataSelect={this.onDataSelect}
                                   loading={this.state.loading}/>
                    </div>
                </div>
            </>
        );
    };

    onDataSelect = (data) => {
        window.location.href = "#customerSave?" + data.userId;
    }


}
